<template>
  <button
    class="btn-stats"
    :class="{
      active
    }"
    aria-label="Stats"
    @click="() => $emit('click')"
  >
    <InlineSvg
      width="12px"
      height="12px"
      alt="Stats"
      :class="{ active }"
      icon="~public/images/inline/widget.svg"
    />
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="sass" scoped>
.btn-stats .inline-svg{
  color: #999;
  &.active{
    color: #ffca27
  }
}
[data-mode="light"] .btn-stats .inline-svg{
  &.active{
    color: #EE6723;
  }
}
</style>
